import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-39",
  "use": "icon-sheet_icon-39-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-39\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path d=\"M2.721 20.863h19M2.721 3.471v17.392M20.39 6.353l.664 3.434M20.39 6.353l-3.834.457\" /><path stroke-linejoin=\"round\" d=\"M5.202 17.353l5.331-5.203 2.725 2.737 7.132-8.534\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol